import { Component, OnInit, Input, HostListener, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { ErrorService } from '../error/error.service';
import { AppService } from '../../app.service';
import { AccessibilityService } from '../../services/accessibility.service';
import { BuywifiService } from '../../services/buywifi.service';
import { PaymentService } from './payment.service';
import { DatalayerService } from '../../services/datalayer.service';
import { SharedService } from '@flysas/payment';
import { CheckoutReviewService } from './services/checkout-review.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html'
})
export class PaymentComponent implements OnInit, OnDestroy {

  @Input() public wifiKey: number;
  public currentSegment: any;
  public price: number;
  public sasPaymentTncData: any;
  public payErrorResponse;
  public ccIframe;
  public creditCardFrameId;
  public maxretryError: boolean;
  public selectedCurrency: any;
  reviewCallSubscripton: Subscription;
  showOptions: any;
  isDesktop: boolean;
  optionsApiResolved = false;

  constructor(private router: Router,
    private buywifiService: BuywifiService, private accessibilityService: AccessibilityService,
    public appService: AppService, private buyWifiService: BuywifiService,
    private errorService: ErrorService, private paymentService: PaymentService,
    private datalayerService: DatalayerService, private sharedService: SharedService,
    private reviewService: CheckoutReviewService) { }

  ngOnInit() {
    this.reviewService.resetGiftCardDetails();
    this.buyWifiService.setCurrentState(1);
    this.datalayerService.pushInformationToDataLayer('wifi-payment');
    this.wifiKey = this.buywifiService.getSessionValue();
    this.currentSegment = this.buywifiService.getCurrentSegment();
    this.price = this.buywifiService.getCurrentPrice();
    this.getPaymentTnCData();
    this.accessibilityService.focus('.icon-logo');
    this.paymentService.getMaxRetryError$.subscribe(value => {
      this.maxretryError = value;
    })
    this.paymentService.setPaymentInputData();
    this.paymentService.setGiftCardTotal(null);
    this.sharedService.setZeroTotalPayableAmount(false);
    this.sharedService.setReviewErrors(null);
    this.sharedService.setCallAncCheckoutReview(false);
    this.selectedCurrency = this.buyWifiService.selectedCurrency;
    this.paymentService.clearMaxretryLimit();
    this.sharedService.setConfirmTriggered(false);
    this.paymentService.setConfirmTriggered(false);
    this.sharedService.setOnBoard(true);
    this.appService.hideLoaderWithText();
    this.accessibilityService.setSkipLinkId('review-pay');
    this.reviewCallSubscripton = this.sharedService.getCallAncCheckoutReview.subscribe(value => {
      if (value) {
        this.paymentService.setLoaderPayBtn(true);
        this.reviewService.callCheckoutReview()
          .subscribe(response => {
            this.paymentService.setLoaderPayBtn(false);
            this.paymentService.setIsGiftCard(false);
            this.sharedService.setVoucherReachedMaxLimit(false);
            this.updatePricing(response);
            //console.log("updatePrice", response);
          }, (err) => {
            const notification = {
              'notification': [
                {
                  'code': '70550012',
                  'description': 'An internal error'
                }
              ]
            };
            this.paymentService.setIsGiftCard(false);
            this.updatePricing(notification);
            this.sharedService.setVoucherReachedMaxLimit(false);
          });
      }
    });

    this.sharedService.getPaymentOptionsOutput$.subscribe(paymentOptionsOutput => {
      if (paymentOptionsOutput.selectedGroup !== undefined || paymentOptionsOutput.selectedMethod !== undefined) {
        this.paymentService.setSelectedGroup(paymentOptionsOutput.selectedGroup);
        this.optionsApiResolved = true;

      }
    });
  }



  public redirectHome() {
    location.reload(true);
  }


  getPaymentTnCData(): any | undefined {
    if (this.paymentService.getPaymentTnCData()) {
      this.paymentService.getPaymentTnCData().subscribe(tncData => {
        this.sasPaymentTncData = tncData;
      });
    } else {
      return undefined;
    }

  }

  nextKeyFocus(event, selector) {
    event.preventDefault();
    event.stopPropagation();
    this.accessibilityService.focus(selector);
  }
  onTabFromtANDc(event) {
    event.preventDefault();
    event.stopPropagation();
    setTimeout(function () {
      this.accessibilityService.focus('.sasPaymentPayNowButton');
    }, 100);
  }

  backToView() {
    this.maxretryError = false;
    this.paymentService.clearMaxretryLimit();
    this.appService.hideLoaderWithText();
    this.router.navigate(['/home']);
    location.reload(true);
  }




  @HostListener('window:keydown', ['$event'])
  keyEvent(event) {
    if (!event.shiftKey && event.target.id === 'sasPaymentPayNowButton' && event.keyCode === 9) {
      event.preventDefault();
      this.accessibilityService.focus('.icon-logo');
    } else if (!event.shiftKey && event.target.id === 'sasPayTnCAcc' && event.keyCode === 9) {
      event.preventDefault();
      this.accessibilityService.focus('#termsAndConditionSASClose');
    }
  }

  updatePricing(response) {
    this.paymentService.setLoaderPayBtn(false);
    this.paymentService.setGiftCardTotal(null);
    this.sharedService.setZeroTotalPayableAmount(false);
    this.sharedService.setVoucher(null);
    this.sharedService.setReviewErrors(null);
    if (response.errors) {
      this.sharedService.setReviewErrors(response.errors);
    }
    if (response.notification && response.notification.length > 0) {
      const errCode = {
        'errors': [
          {
            'errorCode': response.notification[0].code,
            'errorMessage': response.notification[0].description
          }
        ]
      };
      this.sharedService.setReviewErrors(errCode.errors);
    }
    if (response.voucherPaymentInfo) {
      this.paymentService.setIsGiftCard(true);
      this.paymentService.setPaymentInfo(response.voucherPaymentInfo);
      const giftCard = [];
      for (const voucherPaymentInfo of response.voucherPaymentInfo) {
        if (voucherPaymentInfo.type.toLowerCase() === 'vc' && voucherPaymentInfo.voucher) {
          giftCard.push(voucherPaymentInfo);
        }
      }
      if (giftCard.length > 0) {
        this.sharedService.setEmptyVoucher(false);
        this.sharedService.setVoucher(giftCard);
      } else {
        this.sharedService.setEmptyVoucher(true);
      }
      if (giftCard.length >= 2) {
        this.sharedService.setVoucher(giftCard);
        this.sharedService.setVoucherReachedMaxLimit(true);
      }
      this.zeroPay(response);
    }
  }
  zeroPay(response) {
    if (response.price && response.price.hasOwnProperty('amountToPay')) {
      this.paymentService.setGiftCardTotal(response.price.amountToPay);
      if (response.price.amountToPay === 0) {
        this.sharedService.setZeroTotalPayableAmount(true);
        //console.log("insidezeroPay Condition True");
      } else {
        this.sharedService.setZeroTotalPayableAmount(false);
      }
    }
  }

  ngOnDestroy() {
    if (this.reviewCallSubscripton !== undefined) {
      this.reviewCallSubscripton.unsubscribe();
    }
  }


}
